import React from 'react';
import FAQscontentmangement from '../sections/sec-contentmangement-faqs';
const Contentmangementfaqs = () => {
    return ( 
        <>
         <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
                    <FAQscontentmangement />
        </section>
        </>
     );
}
 
export default Contentmangementfaqs;